<ng-container *ngIf="userDoc$ | async as user">

  <div class="btn btn-blank h-100 d-flex align-items-center" (click)="toggleMode(user.uid, !user.settings.darkMode)">
    <fa-icon [icon]="currentModeIcon" [fixedWidth]="true"></fa-icon>
  </div>

</ng-container>